import { render } from "./update-delivery-form-section.vue?vue&type=template&id=63b58ecc&scoped=true&ts=true"
import script from "./update-delivery-form-section.vue?vue&type=script&lang=ts"
export * from "./update-delivery-form-section.vue?vue&type=script&lang=ts"

import "./update-delivery-form-section.vue?vue&type=style&index=0&id=63b58ecc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b58ecc"]])

export default __exports__